import { render, staticRenderFns } from "./AddAnswer.vue?vue&type=template&id=f5b1d4d8&"
import script from "./AddAnswer.vue?vue&type=script&lang=js&"
export * from "./AddAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports